import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import Contact from '@/components/Contact'
import ProductIndex from '@/components/products/Index'
import HuanZaiJin from '@/components/products/HuanZaiJin'
import TaiSuiDian from '@/components/products/TaiSuiDian'
import WenWuCaiShenBaoKu from '@/components/products/WenWuCaiShenBaoKu'
import ZhuGeKongMingChenTanXiang from '@/components/products/ZhuGeKongMingChenTanXiang'
import WanFoShenXiangYou from '@/components/products/WanFoShenXiangYou'
import WanFoShenQiYe from '@/components/products/WanFoShenQiYe'
import WenChangJin from '@/components/products/WenChangJin'
import ShouShengQian from '@/components/products/ShouShengQian'
import DiZhuJin from '@/components/products/DiZhuJin'
import TianGuanJin from '@/components/products/TianGuanJin'
import NanDouLiuXingYanShouDeng from '@/components/products/NanDouLiuXingYanShouDeng'
import TaiSuiJin from '@/components/products/TaiSuiJin'
import SanHeYiDaZhuanYunFa from '@/components/products/SanHeYiDaZhuanYunFa'

Vue.use(Router)

/* eslint-disable */
export default new Router({
  mode: 'history',
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash, offset: { x: 0, y: 200 } }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/contact-us',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/products',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: '',
          component: ProductIndex,
          name: 'ProductIndex'
        },
        {
          path: 'huan-zai-jin',
          name: 'HuanZaiJin',
          component: HuanZaiJin
        },
        {
          path: 'tai-sui-dian',
          name: 'TaiSuiDian',
          component: TaiSuiDian
        },
        {
          path: 'wen-wu-cai-shen-bao-ku',
          name: 'WenWuCaiShenBaoKu',
          component: WenWuCaiShenBaoKu
        },
        {
          path: 'zhu-ge-kong-ming-chen-tan-xiang',
          name: 'ZhuGeKongMingChenTanXiang',
          component: ZhuGeKongMingChenTanXiang
        },
        {
          path: 'wan-fo-shen-xiang-you',
          name: 'WanFoShenXiangYou',
          component: WanFoShenXiangYou
        },
        {
          path: 'wan-fo-shen-qi-ye',
          name: 'WanFoShenQiYe',
          component: WanFoShenQiYe
        },
        {
          path: 'wen-chang-jin',
          name: 'WenChangJin',
          component: WenChangJin
        },
        {
          path: 'shou-sheng-qian',
          name: 'ShouShengQian',
          component: ShouShengQian
        },
        {
          path: 'di-zhu-jin',
          name: 'DiZhuJin',
          component: DiZhuJin
        },
        {
          path: 'tian-guan-jin',
          name: 'TianGuanJin',
          component: TianGuanJin
        },
        {
          path: 'nan-dou-liu-xing-yan-shou-deng',
          name: 'NanDouLiuXingYanShouDeng',
          component: NanDouLiuXingYanShouDeng
        },
        {
          path: 'tai-sui-jin',
          name: 'TaiSuiJin',
          component: TaiSuiJin
        },
        {
          path: '3-he-1-da-zhuan-yun-fa',
          name: 'SanHeYiDaZhuanYunFa',
          component: SanHeYiDaZhuanYunFa
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js